import React, { useCallback } from 'react'

import { AIGenerated, Icon } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { number, string } from 'prop-types'

import I18n from 'Pods/Shared/I18n'

const TRANSLATION_KEY_PREFIX = 'subscription_upgrade.explainer'

function ExplainerBanner({ downloadsUsed, unusedCredits, locale = 'en' }) {
  const translate = useCallback(
    (key, options = {}) => I18n.t(`${TRANSLATION_KEY_PREFIX}.${key}`, { ns: 'rails', lng: locale, ...options }),
    [locale],
  )

  const limit = downloadsUsed + unusedCredits

  return (
    <div className="upgrade-explainer">
      <span className="upgrade-explainer__icon" aria-hidden="true">
        <Icon svgComponent={AIGenerated} color="primary" size="small" notSpaced />
      </span>
      <p className="upgrade-explainer__text cgt-body-base">
        {translate('prefix')}{' '}
        <strong>{translate('used_of_limit', { used: downloadsUsed, limit })}</strong>{' '}
        {translate('middle')}{' '}
        <strong>{translate('unused', { unused: unusedCredits })}</strong>{' '}
        {translate('suffix')}
      </p>
    </div>
  )
}

ExplainerBanner.propTypes = {
  downloadsUsed: number.isRequired,
  unusedCredits: number.isRequired,
  locale: string,
}

export default ExplainerBanner
